import {FLAG_PREFIX} from "../../constants/tokens";

export const getPlayerFlagToken = (player) => {
  return FLAG_PREFIX + player.color;
}